import service from "@irati-tracking/tracker"

const tracking = {
  view: (page: string, data?: object) => {
    service.trackPlatformEvent(`platform_view_${page}`, data)
  },
  click: (item: string, data: object) => {
    service.trackPlatformEvent(`platform_click_${item}`, data)
  },
  dismiss: (type: string, source: string, data: object) => {
    service.trackPlatformEvent("platform_dismiss", {...data, type, source})
  },
  openLiveChat: () => {
    service.trackPlatformEvent("platform_opened_live_chat", {})
  },
  clickHeaderHomeButton: (data: object) => {
    service.trackPlatformEvent("platform_click_header_home", data)
  },
  clickHeaderMyAccount: (data: object) => {
    service.trackPlatformEvent("platform_click_header_myaccount", data)
  },
  notificationOptInSkipped: () => {
    service.trackPlatformEvent("platform_notifications_optin_skipped", {})
  },
  notificationOptInStarted: () => {
    service.trackPlatformEvent("platform_notifications_optin_started", {})
  },
  notificationOptInCompleted: (status: string) => {
    service.trackPlatformEvent("platform_notifications_optin_completed", {status})
  },
  notificationOptInSeen: () => {
    service.trackPlatformEvent("platform_notifications_optin_seen", {})
  },
  loadingSeen: () => {
    service.trackPlatformEvent("platform_loading_seen", {})
  },
  loadingCompleted: () => {
    service.trackPlatformEvent("platform_loading_completed", {})
  },
  onBoarding: (step: string) => {
    service.trackPlatformEvent("onboarding_view_step", {step})
  },
  onBoardingComplete: () => {
    service.trackPlatformEvent("onboarding_complete", {})
  },
  navigationClick: (data: object) => {
    service.trackPlatformEvent("navigation_button_click", data)
  },
  updateAppPrompt(type: string) {
    const data = {
      type,
      source: "force_update"
    }
    service.trackPlatformEvent("platform_update_app_prompt", data)
  },
  startOTP: () => {
    service.trackEvent("login_page")
  },
  submitEmail: () => {
    service.trackEvent("submit_email")
  },
  submitOTP: () => {
    service.trackEvent("submit_otp")
  },
  successOTP: () => {
    service.trackEvent("success_otp")
  },
  errorOTP: (errorMessage: string) => {
    service.trackEvent("error_otp", {errorMessage})
  },
  resendOTP: () => {
    service.trackEvent("resend_otp")
  },
  enterDomain: () => {
    service.trackEvent("domain_page")
  },
  submitDomain: () => {
    service.trackEvent("submit_domain")
  },
  enterSSO: () => {
    service.trackEvent("sso_login")
  },
  clickPasswordSSOLogin: () => {
    service.trackEvent("login_password_sso")
  },
  emailPasswordSubmitted: () => {
    service.trackEvent("submit_email_password")
  },
  enterTermsAndConditions: () => {
    service.trackEvent("enter_t_&_c")
  },
  completeActivation: () => {
    service.trackEvent("complete_activation")
  },
  enterEmail: () => {
    service.trackEvent("enter_email")
  },
  enterOTP: () => {
    service.trackEvent("enter_otp")
  },
  enterPassword: () => {
    service.trackEvent("enter_password")
  },
  successCreatePassword: () => {
    service.trackEvent("success_create_password")
  }
}

export default tracking
